import { ExtractPropTypes, PropType } from 'vue';
import { FilePondOptions } from 'filepond';

export const props = {
  options: {
    type: Object as PropType<FilePondOptions>,
    default: () => ({}),
  },
};

export type Props = ExtractPropTypes<typeof props>;
